import appLocaleData from 'react-intl/locale-data/fr';

const saLang = {
    messages: {},
    locale: 'fr-FR',
    data: appLocaleData,
};
export default saLang;
